import { cx } from "@linaria/core";
import { FC } from "react";
import { ListDottedImage } from "@/components/LandingResources/ListDotted";
import { StyledH2 } from "@/components/LandingResources/StyledResources";
import { Container } from "@/styles/utils/StyledGrid";
import { cssTextCenter, cssTextUpper, Section } from "@/styles/utils/Utils";
import { colors } from "@/styles/utils/vars";
import { TITLE_SITE_RU } from "@/utils/constants";
const SectionSomeAbout: FC = () => {
  return <Section style={{
    backgroundColor: colors.grayLight
  }}>
      <Container variantWidth={"1266px"}>
        <StyledH2 className={cx(cssTextUpper, cssTextCenter)}>
          Немного об интернет-магазине {TITLE_SITE_RU}
        </StyledH2>
        <ListDottedImage image={"/images/landings/partner/workers.jpg"} />
      </Container>
    </Section>;
};
export { SectionSomeAbout };